export const GET_INVESTMENTS_REQUESTS_REQUEST = 'GET_INVESTMENTS_REQUESTS_REQUEST';
export const GET_INVESTMENTS_REQUESTS_SUCCESS = 'GET_INVESTMENTS_REQUESTS_SUCCESS';
export const GET_INVESTMENTS_REQUESTS_FAILURE = 'GET_INVESTMENTS_REQUESTS_FAILURE';

export const CHANGE_INVESTMENT_REQUEST_STATUS_REQUEST = 'CHANGE_INVESTMENT_REQUEST_STATUS_REQUEST';
export const CHANGE_INVESTMENT_REQUEST_STATUS_SUCCESS = 'CHANGE_INVESTMENT_REQUEST_STATUS_SUCCESS';
export const CHANGE_INVESTMENT_REQUEST_STATUS_FAILURE = 'CHANGE_INVESTMENT_REQUEST_STATUS_FAILURE';
